import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=25877fc1&"
import script from "./menuList.vue?vue&type=script&lang=ts&"
export * from "./menuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports